<template>
    <transition name="fade" v-if="enableTool">
        <ControlAddFeature
            v-if="enableAddFeature"
            :data-panel="pageID"
            :idControl="pageID"
            :baseTranslateID="translateID"
            :actionName="actionName"
            :moduleCode="moduleCode"
            :showButtonOnActionMap="showButtonOnActionMap"
            :eventInitialize="eventInitialize"
            :eventConfirmGeometry="eventConfirmGeometry"
            :eventFinished="eventFinished"
            :eventShowModal="eventShowModal"
            />
    </transition>
</template>

<script>
    import ToolMixin from './mixins/ToolMixin';
    import { MAP_ACTIONS } from '@config/constants';
    import { EVENTS } from '@/app/shared/utils/constants';

    export default {
        mixins: [
            ToolMixin,
        ],
        components: {
            ControlAddFeature: () => import(/* webpackChunkName: "control-addfeature" */ '@/components/maps/control/addFeatureControl'),
        },
        props: {
            toolId: {
                type: String,
                required: true,
            },
            translateID: {
                type: String,
                default: null,
            },
            actionName: {
                type: String,
                default: MAP_ACTIONS.NEW_OCCURRENCE,
            },
            eventInitialize: {
                type: String,
                default: EVENTS.INITIALIZE_NEW_FEATURE,
            },
            eventConfirmGeometry: {
                type: String,
                default: EVENTS.CONFIRM_GEOMETRY_NEW_FEATURE,
            },
            eventFinished: {
                type: String,
                default: EVENTS.FINISHED_NEW_FEATURE,
            },
            eventShowModal: {
                type: String,
                default: EVENTS.SHOW_MODAL_NEW_FEATURE,
            },
        },
        data() {
            return {
                pageID: this.toolId,
            }
        },
        computed: {
            enableAddFeature() {
                return this.checkTool(this.pageID) && this.$auth.check(this.acl[`add${this.capitalizeFirstLetter(this.pageID.replace(/add/, ''))}`]);
            },
        },
        methods: {
            capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
        }
    }
</script>